'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blockRenderMapForSameWrapperAsUnorderedListItem = exports.WRAPPER = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// https://github.com/facebook/draft-js/blob/0.10-stable/src/model/immutable/DefaultDraftBlockRenderMap.js#L22
// <ul className={cx('public/DraftStyleDefault/ul')} />
var WRAPPER = _react2.default.createElement('ul', { className: 'public-DraftStyleDefault-ul' });

var blockRenderMap = (0, _immutable.Map)(_defineProperty({}, _constants.CHECKABLE_LIST_ITEM, {
  element: 'li',
  wrapper: WRAPPER
}));

var blockRenderMapForSameWrapperAsUnorderedListItem = blockRenderMap.merge((0, _immutable.Map)(_defineProperty({}, _constants.UNORDERED_LIST_ITEM, {
  element: 'li',
  wrapper: WRAPPER
})));

exports.default = blockRenderMap;
exports.WRAPPER = WRAPPER;
exports.blockRenderMapForSameWrapperAsUnorderedListItem = blockRenderMapForSameWrapperAsUnorderedListItem;